var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#09090B",
    strokeWidth: 1.5,
    d: "M13 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v1.391a1 1 0 0 0 .315.729l3.87 3.643a1 1 0 0 1 .315.728v3.246a1 1 0 0 0 1.229.974l1-.236a1 1 0 0 0 .771-.973V8.491a1 1 0 0 1 .315-.728l3.87-3.643A1 1 0 0 0 13 3.39z"
  })));
};
export default SvgFilter;